import {
  ChangeDetectorRef,
  Component,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { forkJoin, map, mergeMap, switchMap } from 'rxjs';
import { hasServiceOrder } from 'src/entities/file/lib/service-table.utils';
import { applyCreatedOrdersToServices } from 'src/entities/order';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { LoadingService } from 'src/app/services/loading.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.css']
})
export class ProgramacionComponent implements OnInit {
  loader: boolean = false;
  model: any = null;
  listFileProduct: any = [];
  files: any = [];
  modelExpand: any;
  estadoBtnMasivo: any = 0;

  messageButtonOS: any = 0;
  loadingOS: boolean = false;
  resultOS: any;

  startDate: Date | any;
  endDate: Date | any;
  startDate2: Date | any;
  endDate2: Date | any;

  selectedFile: string | null = null;
  selectedEstadoFile: string | null = null;
  selectedSubCategoria: string | null = null;
  selectedCategoriaProducto: string | null = null;
  selectedSubCategoriaProducto: string | null = null;
  selectedTipoServicio: string | null = null;

  selectedService: string | null = null;
  selectedProvider: string | null = null;
  selectedOS: string | null = null;
  selectedEstadoOS: string | null = null;

  arraySubCategoria: any = [];
  arrayCategoriaProducto = ['BIKINGADVENTURES', 'HIKING&TREKKING'];
  arrayEstadoFile = [
    'APROBADO',
    'NO APROBADO',
    'NUEVO PEDIDO',
    'ANULADO',
    'POSTERGADO',
    'EN PROCESO',
    'CONFIRMADO',
    'RECONFIRMADO',
    'PROGRAMADO',
    'EN OPERACION',
    'OPERADO',
    'CERRADO'
  ];
  arraySubCategoriaProducto = [
    'TREKKING',
    'HIKING',
    'SELFGUIDEDHIKES',
    'TRAILRUN',
    'LODGETOLODGETREKS',
    'ROADBIKES',
    'MOUNTAINBIKES',
    'SELFGUIDEDBIKETOURS',
    'EBIKES'
  ];
  arrayTipoServicio = ['GUIA', 'PERSONALDECAMPO'];
  arrayService: any = [];
  arrayProvider: any = [];
  arrayOS: any = [];
  arrayEstadoOS = [
    'CONFIRMADO',
    'EN PROCESO',
    'PAGADO',
    'CANCELADO',
    'ELIMINADO',
    'NOTACREDITO'
  ];

  services: any[] = [];
  fileArray: any[] = [];

  //dateRangeForm: FormGroup | undefined;

  range!: FormGroup;
  // range = new FormGroup({
  //   start: new FormControl<Date | null>(null),
  //   end: new FormControl<Date | null>(null),
  // });

  displayedColumnsServicios = [
    'Check',
    'fileNumber',
    'estadoFile',
    'orderNumber',
    'tipoMoneda',
    'proveedor',
    'categoriaProducto',
    'subCategoriaProducto',
    'ruta',
    'nombre',
    'categoriaServicio',
    'numPAX',
    'reservationStatus',
    'reservationNumber',
    'createdAt',
    'updatedAt',
    'cambiarProvider'
  ];

  selected: any = 'All';
  dataModel: any;
  dataFinal: any;
  uniqueIDfiles: any;
  loaderCambio: boolean = false;
  loaderInitial: boolean = false;

  usuario: string = '';
  email: string = '';

  dataSource = new MatTableDataSource<any>();

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataSource.sort = value;
  }

  constructor(
    private readonly functions: FunctionsService,
    private readonly changeDetectorRefs: ChangeDetectorRef,
    private readonly fileService: FileService,
    private readonly functionsService: FunctionsService,
    public dialog: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    /*     this.userService.getAuthenticatedUser().then((data) => {
      this.usuario = `${data.attributes.middle_name} ${data.attributes.family_name}`;

      console.log('user', this.usuario);
    }) */
    this.usuario = `${localStorage.getItem('nombre')} ${localStorage.getItem(
      'apellido'
    )}`;
    this.email = `${localStorage.getItem('email')}`;

    this.functionsService.disparadorCambios.subscribe((tipo: string) => {
      this.loadProgramacion();
    });
    this.loadProgramacion();
  }

  loadProgramacion() {
    //this.loaderInitial = true
    this.loader = true;
    this.fileService
      .getServicesAllFiles()
      .pipe(
        map((d) => d.getAllServicesInFiles),
        map((data) => {
          console.log(data);
          const dataFilter = data?.filter(
            (service: any) =>
              (service.objProducto?.categoriaProducto === 'HIKING&TREKKING' ||
                service.objProducto?.categoriaProducto == 'BIKINGADVENTURES') &&
              (service.tipoServicio == 'PERSONALDECAMPO' ||
                service.tipoServicio == 'GUIA')
          );
          return dataFilter;
        }),
        map((data) => {
          const arrayFilesNumber = data.map(
            (service: any) => service.fileNumber
          );
          let uniqueIDfiles = [...new Set(arrayFilesNumber)].map(
            (item: any) => ({
              fileNumber: item,
              services: []
            })
          );

          uniqueIDfiles.forEach((fileObj: any) => {
            data.forEach((service: any) => {
              console.log('SERVICE');
              console.log(service);
              if (fileObj.fileNumber === service.fileNumber) {
                fileObj.services.push({ ...service, checked: false });
                ((fileObj.cantPersonal = service.cantPersonal),
                  (fileObj.costo = service.costo),
                  (fileObj.day = service.day),
                  (fileObj.lstPaX = service.lstPaX),
                  (fileObj.margen = service.margen),
                  (fileObj.price = service.price),
                  (fileObj.tipoMoneda = service.tipoMoneda),
                  (fileObj.totalPriceDolares = service.totalPriceDolares),
                  (fileObj.totalPriceSoles = service.totalPriceSoles),
                  (fileObj.utilidad = service.utilidad),
                  (fileObj.estadoReserva = service.order?.reservationStatus),
                  (fileObj.categoriaProducto =
                    service.objProducto.categoriaProducto),
                  (fileObj.subCategoriaProducto =
                    service.objProducto.subCategoriaProducto),
                  (fileObj.ruta = service.objProducto.nombre),
                  // fileObj.id=service.id,
                  (fileObj.objProvider = {
                    nombre: service.objProvider.nombre
                  }),
                  (fileObj.fileNumber = service.fileNumber),
                  (fileObj.razonSocial = service.objProvider.razonSocial),
                  // fileObj.nameEmpresa=service.nameEmpresa,
                  (fileObj.numOS = service.order?.orderNumber),
                  (fileObj.idProducto = service.productId),
                  (fileObj.idProveedor = service.providerId),
                  (fileObj.idServicio = service.serviceId),
                  (fileObj.idTarifa = service.tarifaId),
                  (fileObj.isDeleted = service.isDeleted),
                  (fileObj.nombreServicio = service.nombreServicio),
                  (fileObj.tipoServicio = service.tipoServicio),
                  (fileObj.categoriaServicio =
                    service.objServicio.categoriaServicio),
                  (fileObj.nombre = service.objProvider.nombre),
                  // fileObj.itineraryIndex: itineraryIndex,
                  (fileObj.idItinerary = service.itineraryId));
                // fileObj.nameClient=service.fileProduct.nameClient
              }
            });
          });

          this.uniqueIDfiles = uniqueIDfiles;
          return uniqueIDfiles;
        }),
        mergeMap((dataTotal: any) => {
          return forkJoin(
            dataTotal.map((item: any) =>
              this.fileService.getItineraryPassengers(item.idItinerary)
            )
          );
        }),
        map((itineraryPassengers: any) => {
          console.log(itineraryPassengers);
          return this.uniqueIDfiles.map((item: any, index: any) => {
            item.updatedAt =
              itineraryPassengers[index]?.getItinerary?.updatedAt;
            item.createdAt =
              itineraryPassengers[index]?.getItinerary?.createdAt;
            return item;
          });
        })
      )
      .subscribe({
        next: (data) => {
          this.dataFinal = data;
          console.log('hi');
          console.log(this.dataFinal);
          this.dataModel = this.dataFinal;
          let array: any[] = [];
          this.services = [];
          this.dataModel.map((el: any) => {
            el.services.map((service: any) => {
              array.push(service.fileNumber);
              this.services.push(service);
            });
          });

          console.log(array);
          console.log(this.services);
          this.fileArray = [...new Set(array)];
          const service = this.services.map((item: any) => item.nombreServicio);
          this.arrayService = [...new Set(service)];
          const provider = this.services.map(
            (item: any) => item.objProvider.nombre
          );
          this.arrayProvider = [...new Set(provider)];
          const categoriaServicio = this.services.map(
            (item: any) => item.objServicio.categoriaServicio
          );
          this.arraySubCategoria = [...new Set(categoriaServicio)];
          const OS = this.services.map((item: any) => item.order?.orderNumber);
          const filteredOS = OS.filter((item: any) => item != null);
          this.arrayOS = [...new Set(filteredOS)];
          const estadoOS = this.services.map(
            (item: any) => item.order?.reservationStatus
          );
          this.model = this.services;
          this.applyFilterSelect();
        },
        complete: () => {
          //this.arrayEstadoOS = [...new Set(estadoOS)]

          this.dataSource = new MatTableDataSource(this.model);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.changeDetectorRefs.detectChanges();

          this.loader = false;
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    changes['dataModel'].currentValue.map((fila: any) => {
      fila.checked = false;
    });
    this.dataSource = new MatTableDataSource(changes['dataModel'].currentValue);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.estadoBtnMasivo = 0;
    this.changeDetectorRefs.detectChanges();
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    console.log(filterValue);
    console.log(this.dataModel);

    this.dataSource.data.forEach((element: { [x: string]: string }) => {
      for (const key in element) {
        if (!element[key] || element[key] === null) {
          element[key] = '';
        }
      }
    });

    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  transformDay(range: String, toDay: number) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);
    result.setDate(result.getDate() - toDay);
    console.log(result);
    return result.toString();
  }

  transformDate(range: String) {
    const firstDate = range?.split('-')?.[0]?.trim();
    console.log(firstDate);
    const days = firstDate.split('/')[0];
    const months = firstDate.split('/')[1];
    const year = firstDate.split('/')[2];

    console.log(months + '/' + days + '/' + year);

    var result = new Date(months + '/' + days + '/' + year);

    return result.toString();
  }

  async sendReservaOS(): Promise<any> {
    const serviceIds = [
      ...new Set(
        (this.model ?? [])
          .filter((fila: any) => fila.checked && !hasServiceOrder(fila))
          .map((s: any) => s.id)
          .filter(Boolean)
      )
    ] as string[];
    if (!serviceIds.length) return;

    const operationDates = (this.model ?? [])
      .filter((fila: any) => fila.checked && !hasServiceOrder(fila))
      .map((s: any) => s.startDateService ?? s.serviceDate ?? null);

    const dialogRef = this.functions.openCreateOrderDialog({
      serviceIds,
      operationDates,
      contextLabel: 'Programación'
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) {
        return;
      }

      if (result.shouldRefresh) {
        this.estadoBtnMasivo = 0;
        this.loadProgramacion();
        return;
      }

      if (result.success) {
        applyCreatedOrdersToServices(
          this.model ?? [],
          result.result?.createdOrders,
          'id',
          result.submittedInput
        );
        this.model.map((fila: any) => {
          fila.checked = false;
        });
        this.dataSource = new MatTableDataSource(this.model);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.estadoBtnMasivo = 0;
        this.applyFilterSelect();
        this.changeDetectorRefs.detectChanges();
      }
    });
  }

  updateCheck(row: any) {
    row.checked = !row.checked;
    //console.log('check model', this.model);
    if (row.checked == true) {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) + Number(1);
    } else {
      this.estadoBtnMasivo = Number(this.estadoBtnMasivo) - Number(1);
    }
  }

  isAllSelected(array: any) {
    //console.log('is all cjecked')
    let lstHoteles: any[];
    lstHoteles = array?.filter((x: any) => x.checked == true);
    const numSelected = lstHoteles?.length;
    const numRows = array?.length;
    return numSelected === numRows;
  }

  toggleAllRows(array: any) {
    if (this.isAllSelected(array)) {
      array.map((fila: any) => {
        fila.checked = false;
      });
      console.log(
        'verifica checked',
        array?.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = 0;
      return;
    } else {
      array.map((fila: any) => {
        fila.checked = !fila.checked;
      });
      console.log(
        'verifica checked',
        array?.filter((x: any) => x.checked == true)
      );
      this.estadoBtnMasivo = array?.length;
      return;
    }
  }

  openDialogProvider(
    tipo: String,
    nombreServicio: String,
    idItinerary: String,
    idRegistro: string,
    nombreProveedor: string,
    categoriaServicio: string,
    locacion: string
  ) {
    this.functions.openDialogProvider(
      tipo,
      nombreServicio,
      idItinerary,
      idRegistro,
      nombreProveedor,
      'All',
      categoriaServicio,
      locacion
    );
  }

  applyFilterSelect() {
    let dataNew: any = this.services;

    if (this.selectedFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileNumber === this.selectedFile
      );
    }
    if (this.selectedEstadoFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.estadoFile === this.selectedEstadoFile
      );
    }
    if (this.selectedSubCategoria) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.objServicio.categoriaServicio === this.selectedSubCategoria
      );
      // dataNew= this.model.map((element:any) => {
      //   return {...element, services: element.services.filter((service:any) => service.categoriaServicio === this.selectedSubCategoria)}
      // })
    }
    if (this.selectedCategoriaProducto) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.objProducto.categoriaProducto === this.selectedCategoriaProducto
      );
    }

    if (this.selectedSubCategoriaProducto) {
      dataNew = dataNew?.filter(
        (item: any) =>
          item.objProducto.subCategoriaProducto ===
          this.selectedSubCategoriaProducto
      );
    }

    if (this.selectedTipoServicio) {
      dataNew = dataNew?.filter(
        (item: any) => item.tipoServicio === this.selectedTipoServicio
      );
    }

    if (this.selectedService) {
      dataNew = dataNew?.filter(
        (item: any) => item.nombreServicio === this.selectedService
      );
    }

    if (this.selectedProvider) {
      dataNew = dataNew?.filter(
        (item: any) => item.objProvider.nombre === this.selectedProvider
      );
    }

    if (this.selectedOS) {
      dataNew = dataNew?.filter(
        (item: any) => item.order?.orderNumber === this.selectedOS
      );
    }

    if (this.selectedEstadoOS) {
      dataNew = dataNew?.filter(
        (item: any) => item.order?.reservationStatus === this.selectedEstadoOS
      );
    }

    if (this.startDate && this.endDate) {
      dataNew = dataNew?.filter((item: any) => {
        return (
          new Date(this.startDate) <= new Date(item.objServicio?.createdAt) &&
          new Date(item.objServicio?.createdAt) <= new Date(this.endDate)
        );
      });
    }

    if (this.startDate2 && this.endDate2) {
      dataNew = dataNew?.filter((item: any) => {
        return (
          new Date(this.startDate2) <= new Date(item.objServicio?.updatedAt) &&
          new Date(item.objServicio?.updatedAt) <= new Date(this.endDate2)
        );
      });
    }

    this.dataSource.data = dataNew;
  }

  cleanDateSelected(val: any) {
    if (val == 1) {
      this.startDate = null;
      this.endDate = null;
    } else if (val == 2) {
      this.startDate2 = null;
      this.endDate2 = null;
    }

    this.applyFilterSelect();
  }

  changeValue(type: string) {
    console.log(type);

    this.selected = type;
  }
}
